import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { SmartLink } from './SmartLink';
import { navLinks } from '../data/site';
import { useBooking } from './booking';

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { openBooking } = useBooking();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Always a dark, translucent bar - a touch more opaque once scrolled so the
  // white type stays legible over the lighter sections below.
  const opaque = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 backdrop-blur-md transition-all duration-500 ${
        opaque ? 'bg-navy-deep/85' : 'bg-navy-deep/35'
      }`}
    >
      <div className="container-content section-pad relative flex h-[76px] items-center justify-between">
        <Link to="/" aria-label="Flying Muse home" onClick={() => setOpen(false)}>
          <Logo tone="light" height={38} />
        </Link>

        <nav className="absolute left-1/2 hidden -translate-x-1/2 items-center gap-10 md:flex">
          {navLinks.map((link) => (
            <SmartLink
              key={link.href}
              href={link.href}
              className="font-sans text-[0.7rem] font-medium uppercase tracking-wide2 text-white/85 transition-colors hover:text-white"
            >
              {link.label}
            </SmartLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => openBooking(undefined, undefined, 'header_desktop')}
            className="btn btn-primary hidden sm:inline-flex"
          >
            Book Now
          </button>
          <button
            type="button"
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center text-white md:hidden"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      <div
        className={`overflow-hidden bg-navy-deep/95 backdrop-blur-md md:hidden transition-[max-height] duration-300 ${
          open ? 'max-h-96' : 'max-h-0'
        }`}
      >
        <nav className="section-pad flex flex-col gap-1 py-4">
          {navLinks.map((link) => (
            <SmartLink
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="py-2 font-sans text-sm font-medium uppercase tracking-wide2 text-white/85"
            >
              {link.label}
            </SmartLink>
          ))}
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              openBooking(undefined, undefined, 'header_mobile');
            }}
            className="btn btn-primary mt-3 w-full"
          >
            Book Now
          </button>
        </nav>
      </div>
    </header>
  );
}
